import { useInfiniteMailFolders } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	SelectItemType,
} from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useState } from 'react';

type InFolderConditionType = {
	name: string;
	defaultValue: any;
	changeCallback: (value: any) => void;
};

function InFolderCondition(props: InFolderConditionType) {
	const { control } = useFormContext();

	const { data, status } = useInfiniteMailFolders();
	const [folderOptions, setFolderOptions] = useState<Array<SelectItemType>>([]);

	const IterateData = () => {
		const NewFolderOptions: Array<SelectItemType> = [];

		data?.pages.forEach(
			(page) =>
				page?.data &&
				page.data.filter((folder, index: number) =>
					folder ? NewFolderOptions.push({ label: folder.name, value: folder.id }) : null,
				),
		);

		setFolderOptions(NewFolderOptions);
	};

	useEffect(() => {
		if (data) {
			IterateData();
		}
	}, [data]);

	return (
		<Controller
			control={control}
			name={props.name}
			defaultValue={props.defaultValue}
			rules={{ required: 'Folders is required' }}
			render={({ field, fieldState }) => (
				<ComboBoxControl
					data={folderOptions}
					defaultValue={field.value}
					forwardValuesCallback={(val) => {
						field.onChange(val);
					}}
					name={field.name}
					placeholder='Select Folders...'
					loading={status === 'pending'}
					disabled={status === 'error'}
					valueType='number'
					displayType={ComboBoxTypeEnum.Multi}
					displayItemLabelType={ComboBoxItemDisplayEnum.Label}
				/>
			)}
		/>
	);
}

export { InFolderCondition };
